import { useSelector } from 'react-redux';
import { selectPatients } from './patients.selectors';

export const useSelectPatients = () => useSelector(selectPatients);
